var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxListCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 4.66797H9.99984V6.0013H2.6665V4.66797ZM2.6665 7.33464H9.99984V8.66797H2.6665V7.33464ZM2.6665 10.0013H7.33317V11.3346H2.6665V10.0013ZM12.8658 8.19597L9.99917 11.0566L9.13784 10.196L8.19517 11.1393L9.99917 12.942L13.8072 9.13997L12.8658 8.19597Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxListCheck);
export default __webpack_public_path__ + "static/media/bx-list-check.e0f5b2bd8908169b0b3befc2883f6918.svg";
export { ForwardRef as ReactComponent };